import GreenTick from "../../Assets/green-tick.svg";

export const appStatus = {
  app: {
    pending: {
      name: "Draft",
      status: 0,
      class: "",
    },
    published: {
      name: "Published",
      status: 1,
      class: "text-dark-mint",
      icon: GreenTick,
    },
    unpublished: {
      name: "Disabled",
      status: 2,
      class: "",
    },
  },
  release: {
    pending: {
      name: "Draft", //pending
      status: 0,
      class: "text-gray",
    },
    activated: {
      name: "Active",
      status: 1,
      class: "text-dark-mint",
    },
    rejected: {
      name: "Rejected", //Rejected
      status: 2,
      class: "text-light-red",
    },
    approved: {
      name: "Approved", //approved
      status: 3,
      class: "text-gray",
    },
    auto_qa: {
      name: "Processing", //auto qa
      status: 4,
      class: "text-sand",
    },
    manual_qa: {
      name: "Under Review", // manula qa
      status: 5,
      class: "text-color-blue",
    },
  },
};

export const orgStatus = {
  pending: {
    //if approval pending even after document updated
    name: "Pending",
    status: 0,
    class: "",
  },
  approved: {
    name: "Approved",
    status: 1,
    class: "",
  },
  rejected: {
    name: "Rejected",
    status: 2,
    class: "",
  },
  draft: {
    //if document not upadted
    name: "Draft",
    status: 3,
    class: "",
  },
  revoked: {
    name: "Revoked",
    status: 4,
    class: "",
  },
};

export const projectStatus = {
  pending: {
    //if approval pending even after document updated
    name: "Pending",
    status: 0,
    class: "",
  },
  approved: {
    name: "Approved",
    status: 1,
    class: "",
  },
  rejected: {
    name: "Rejected",
    status: 2,
    class: "",
  },
  draft: {
    //if document not upadted
    name: "Draft",
    status: 3,
    class: "",
  },
};

export const buildStatus = {
  pending: {
    //processing
    name: "Pending",
    status: 0,
    class: "",
  },
  approved: {
    name: "Approved",
    status: 1,
    class: "",
  },
  rejected: {
    name: "Rejected",
    status: 2,
    class: "",
  },
  draft: {
    name: "Draft",
    status: 3,
    class: "",
  },
  active: {
    name: "Active",
    status: 4,
    class: "",
  },
};

export const publishType = {
  republish: "republish",
  rollback: "rollback",
};
